import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '@mytypes';
import { FetchUsersResponse } from '@mytypes/api/users';
import { fetchUsers } from '~/apiTs';

type UsersState = User[];

const initialState: UsersState = [];

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    initialize: () => initialState,
  },
  // 非同期はextraReducersで行う
  extraReducers: {
    [fetchUsers.fulfilled.type]: (state, action: PayloadAction<FetchUsersResponse>) =>
      action.payload.result,
  },
});

// reducerをexportする
export default usersSlice.reducer;
